import { Box } from '@material-ui/core';
import { ReactElement } from 'react';

import { useWidth } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/hooks/useWidth';
import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

interface PaymentIntentDialogProps {
  children: ReactElement;
}

export const PaymentIntentDialog = ({ children }: PaymentIntentDialogProps) => {
  const { ref, width } = useWidth<HTMLDivElement>();

  const isSmall = width && width < 500;

  return (
    <CustomPaper fill="paper" elevation={1}>
      <div ref={ref}>
        <Box
          gridGap={16}
          display="flex"
          justifyContent="space-between"
          alignItems="flex-start"
          flexDirection={isSmall ? 'column' : 'row'}
        >
          <FlexColumn gridGap={4}>
            <Font variant="subtitle1" color="textPrimary" display="block">
              <Text strong tId="START_PAYMENT_METHOD" />
            </Font>
            <Font variant="body2" color="textPrimary">
              <Text tId="START_PAYMENT_METHOD_DESCRIPTION" />
            </Font>
          </FlexColumn>
          {children}
        </Box>
      </div>
    </CustomPaper>
  );
};
